document.addEventListener("turbolinks:load", function() {
  // 無限ループを防ぐためのフラグ
  var isCalculatingEndTime = false;
  var isCalculatingOperationTime = false;

  // 既存のイベントハンドラを削除して重複を防ぐ
  $(document).off("click", ".add-internal-operation-row");
  $(document).off("click", ".add-internal-operation-bottom");
  $(document).off("change", '#internal-operations-container input[name*="[operation]"]');
  $(document).off("change", "select[id=working_time_leave_class]");
  $(document).off("click", ".remove-internal-operation");
  $(document).off("change", '#internal-operations-container select[name*="[begin("], #internal-operations-container select[name*="[end("]');
  $(document).off("change", '#internal-operations-container select[name*="[operation_hour]"], #internal-operations-container select[name*="[operation_min]"]');

  // ページ読み込み時にsort_orderを初期化
  initializeSortOrder();

  // Function to calculate and set operation time
  function calculateOperationTime(row) {
    if (isCalculatingOperationTime) return;
    isCalculatingOperationTime = true;

    var beginHour = parseInt(row.find('select[name*="[begin(4i)]"]').val(), 10);
    var beginMin = parseInt(row.find('select[name*="[begin(5i)]"]').val(), 10);
    var endHour = parseInt(row.find('select[name*="[end(4i)]"]').val(), 10);
    var endMin = parseInt(row.find('select[name*="[end(5i)]"]').val(), 10);

    if (!isNaN(beginHour) && !isNaN(beginMin) && !isNaN(endHour) && !isNaN(endMin)) {
      var beginTotalMinutes = beginHour * 60 + beginMin;
      var endTotalMinutes = endHour * 60 + endMin;
      var durationInMinutes = endTotalMinutes - beginTotalMinutes;

      if (durationInMinutes >= 0) {
        var durationHours = Math.floor(durationInMinutes / 60);
        var durationMinutes = durationInMinutes % 60;

        row.find('select[name*="[operation_hour]"]').val(durationHours);
        row.find('select[name*="[operation_min]"]').val(durationMinutes);
      }
    }

    isCalculatingOperationTime = false;
  }

  // Function to calculate and set end time from operation time
  function calculateEndTime(row) {
    if (isCalculatingEndTime) return;
    isCalculatingEndTime = true;

    var beginHour = parseInt(row.find('select[name*="[begin(4i)]"]').val(), 10) || 0;
    var beginMin = parseInt(row.find('select[name*="[begin(5i)]"]').val(), 10) || 0;
    var operationHour = parseInt(row.find('select[name*="[operation_hour]"]').val(), 10) || 0;
    var operationMin = parseInt(row.find('select[name*="[operation_min]"]').val(), 10) || 0;

    var beginTotalMinutes = beginHour * 60 + beginMin;
    var operationTotalMinutes = operationHour * 60 + operationMin;
    var endTotalMinutes = beginTotalMinutes + operationTotalMinutes;

    var endHour = Math.floor(endTotalMinutes / 60) % 24;
    var endMin = endTotalMinutes % 60;

    // 直接DOM操作で値を設定
    var endHourSelect = row.find('select[name*="[end(4i)]"]');
    var endMinSelect = row.find('select[name*="[end(5i)]"]');

    if (endHourSelect.length > 0) {
      var endHourOptions = endHourSelect[0].options;
      for (var i = 0; i < endHourOptions.length; i++) {
        if (parseInt(endHourOptions[i].value, 10) === endHour) {
          endHourSelect[0].selectedIndex = i;
          break;
        }
      }
    }

    if (endMinSelect.length > 0) {
      var endMinOptions = endMinSelect[0].options;
      for (var i = 0; i < endMinOptions.length; i++) {
        if (parseInt(endMinOptions[i].value, 10) === endMin) {
          endMinSelect[0].selectedIndex = i;
          break;
        }
      }
    }

    // 終了時間が再計算されたので、作業時間も更新
    calculateOperationTime(row);

    isCalculatingEndTime = false;
  }

  // Event listener for begin time changes - update end time based on operation time
  $(document).on("change", '#internal-operations-container select[name*="[begin(4i)]"], #internal-operations-container select[name*="[begin(5i)]"]', function() {
    var currentRow = $(this).closest('.form-row');
    calculateEndTime(currentRow);
  });

  // Event listener for end time changes - calculate operation time
  $(document).on("change", '#internal-operations-container select[name*="[end(4i)]"], #internal-operations-container select[name*="[end(5i)]"]', function() {
    var currentRow = $(this).closest('.form-row');
    calculateOperationTime(currentRow);
  });

  // Event listener for operation type changes to set default times
  $(document).on("change", '#internal-operations-container input[name*="[operation]"]', function() {
    var operationSelect = $(this);
    var currentRow = operationSelect.closest('.form-row');
    var operationType = operationSelect.val();

    if (!operationType) return;

    var visibleRows = $('#internal-operations-container .internal-operation-row:visible').not('.form-row:last-child');
    var currentIndex = visibleRows.index(currentRow);

    var previousEndHour = null;
    var previousEndMin = null;
    var previousOperationType = null;

    for (var i = currentIndex - 1; i >= 0; i--) {
      var prevRow = visibleRows.eq(i);
      var prevOperationSelect = prevRow.find('input[name*="[operation]"]');
      var prevOperationType = prevOperationSelect.val();
      var prevEndHour = parseInt(prevRow.find('select[name*="[end(4i)]"]').val(), 10);
      var prevEndMin = parseInt(prevRow.find('select[name*="[end(5i)]"]').val(), 10);

      if (prevOperationType && prevEndHour !== undefined && !isNaN(prevEndHour)) {
        previousEndHour = prevEndHour;
        previousEndMin = prevEndMin || 0;
        previousOperationType = prevOperationType;
        break;
      }
    }

    var defaultBeginHour, defaultBeginMin;

    if (operationType === "週次会議") {
      defaultBeginHour = 11;
      defaultBeginMin = 0;
    } else if (operationType === "識学勉強会") {
      defaultBeginHour = 13;
      defaultBeginMin = 0;
    } else if (operationType === "月次会議") {
      if (previousOperationType === "週次会議" && previousEndHour !== null) {
        defaultBeginHour = previousEndHour;
        defaultBeginMin = previousEndMin;
      } else {
        defaultBeginHour = 11;
        defaultBeginMin = 30;
      }
    } else {
      if (currentIndex === 0) {
        defaultBeginHour = 13;
        defaultBeginMin = 0;
      } else if (previousEndHour !== null) {
        defaultBeginHour = previousEndHour;
        defaultBeginMin = previousEndMin;
      } else {
        defaultBeginHour = 13;
        defaultBeginMin = 0;
      }
    }

    if (defaultBeginHour >= 12 && defaultBeginHour < 13) {
      defaultBeginHour = 13;
      defaultBeginMin = 0;
    }

    var beginHourSelect = currentRow.find('select[name*="[begin(4i)]"]');
    var beginMinSelect = currentRow.find('select[name*="[begin(5i)]"]');

    if (beginHourSelect.length > 0) {
      var beginHourOptions = beginHourSelect[0].options;
      for (var i = 0; i < beginHourOptions.length; i++) {
        if (parseInt(beginHourOptions[i].value, 10) === defaultBeginHour) {
          beginHourSelect[0].selectedIndex = i;
          break;
        }
      }
    }

    if (beginMinSelect.length > 0) {
      var beginMinOptions = beginMinSelect[0].options;
      for (var i = 0; i < beginMinOptions.length; i++) {
        if (parseInt(beginMinOptions[i].value, 10) === defaultBeginMin) {
          beginMinSelect[0].selectedIndex = i;
          break;
        }
      }
    }

    var operationHourSelect = currentRow.find('select[name*="[operation_hour]"]');
    var operationMinSelect = currentRow.find('select[name*="[operation_min]"]');

    if (operationHourSelect.length > 0) {
      var operationHourOptions = operationHourSelect[0].options;
      for (var i = 0; i < operationHourOptions.length; i++) {
        if (parseInt(operationHourOptions[i].value, 10) === 0) {
          operationHourSelect[0].selectedIndex = i;
          break;
        }
      }
    }

    if (operationMinSelect.length > 0) {
      var operationMinOptions = operationMinSelect[0].options;
      for (var i = 0; i < operationMinOptions.length; i++) {
        if (parseInt(operationMinOptions[i].value, 10) === 30) {
          operationMinSelect[0].selectedIndex = i;
          break;
        }
      }
    }

    calculateEndTime(currentRow);
  });

  // Event listener for operation time changes
  $(document).on("change", '#internal-operations-container select[name*="[operation_hour]"], #internal-operations-container select[name*="[operation_min]"]', function() {
    var currentRow = $(this).closest('.form-row');
    calculateEndTime(currentRow);
  });
  
  $(document).on("change", "select[id=working_time_leave_class]", function (e) {

    if (e.currentTarget.value !== "time_paid_vacation") {

      // 開始時間を 00:00 に設定
      document.getElementById("working_time_begin_4i").value = "00";
      document.getElementById("working_time_begin_5i").value = "00";

      // 終了時間を 00:00 に設定
      document.getElementById("working_time_end_4i").value = "00";
      document.getElementById("working_time_end_5i").value = "00";

      // 休憩時間を 00:00 に設定
      document.getElementById("working_time_break_hour").value = "0";
      document.getElementById("working_time_break_min").value = "0";

    }

  });

  // 社内業務の削除ボタン機能
  $(document).on("click", ".remove-internal-operation", function(e) {
    e.preventDefault();
    
    var currentRow = $(this).closest('.form-row');
    
    // 既存のデータの場合は_destroy属性を設定
    var destroyInput = currentRow.find('input[name$="[_destroy]"]');
    if (destroyInput.length > 0) {
      destroyInput.val('1');
    } else {
      // 新規追加の場合は_destroy属性を追加
      var operationInput = currentRow.find('input[name$="[operation]"]');
      if (operationInput.length > 0) {
        var inputName = operationInput.attr('name').replace('[operation]', '[_destroy]');
        currentRow.append('<input type="hidden" name="' + inputName + '" value="1">');
      }
    }
    
    // 行を非表示にする
    currentRow.hide();
    
    // 削除後にsort_orderを再設定
    updateSortOrder();
  });

  // 社内業務の追加ボタン機能（行内の追加ボタン）
  $(document).on("click", ".add-internal-operation-row", function(e) {
    e.preventDefault();
    e.stopPropagation(); // イベントのバブリングを停止
    
    var currentRow = $(this).closest('.form-row');
    
    // インデックスを取得
    var time = new Date().getTime();
    
    // テンプレートから新しい行を作成
    var template = $('#internal-operation-template').html();
    var newHtml = template.replace(/__INDEX__/g, time);
    
    // 新しい行を現在の行の上に追加
    currentRow.before(newHtml);
    
    // sort_orderを再設定
    updateSortOrder();
  });

  // 社内業務の追加ボタン機能（一番下の追加ボタン）
  $(document).on("click", ".add-internal-operation-bottom", function(e) {
    e.preventDefault();
    e.stopPropagation(); // イベントのバブリングを停止
    
    var container = $('#internal-operations-container');
    var addButtonRow = $(this).closest('.form-row');
    
    // インデックスを取得
    var time = new Date().getTime();
    
    // テンプレートから新しい行を作成
    var template = $('#internal-operation-template').html();
    var newHtml = template.replace(/__INDEX__/g, time);
    
    // 新しい行を追加ボタンの直前に追加
    addButtonRow.before(newHtml);
    
    // sort_orderを再設定
    updateSortOrder();
  });

});

// sort_orderを初期化する関数
function initializeSortOrder() {
  updateSortOrder();
}

// sort_orderを更新する関数（最適化版）
function updateSortOrder() {
  var container = $('#internal-operations-container');
  var visibleRows = container.find('.internal-operation-row:visible').not('.form-row:last-child');
  
  visibleRows.each(function(index) {
    var row = $(this);
    var sortOrderInput = row.find('input[name$="[sort_order]"]');
    
    if (sortOrderInput.length) {
      sortOrderInput.val(index);
    } else {
      // sort_order入力フィールドがない場合は追加
      var operationInput = row.find('input[name$="[operation]"]');
      if (operationInput.length) {
        var inputName = operationInput.attr('name').replace('[operation]', '[sort_order]');
        row.append('<input type="hidden" name="' + inputName + '" value="' + index + '">');
      }
    }
  });
}